/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectBreadcrumbs from 'domain/projects/project/shared/ProjectBreadcrumbs';
import { SingleBreadcrumbItem, BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useProjectUrl } from 'domain/shared/project';

const SingleProjectBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useProjectUrl();
  const { id } = useParams<Dictionary<string>>();

  return (
    <ProjectBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </ProjectBreadcrumbs>
  );
};

export default SingleProjectBreadcrumbs;
